module.exports = __webpack_public_path__ + "static/spotify-pod-6fb3a916c286afe9928e5d83c9899568.png";